// Scope-dim vocabulary, as a LEAF module (no imports). scoutScope.js and the
// scoped-scout pipelines need this knowledge without dragging apiClient's
// module graph into theirs (several component suites deliberately mock
// dataClient to keep apiClient out entirely).

// Dashboard scope paths use plural dim names; the API uses singular.
export const DIM_SINGULAR = {
  endpoints:   "endpoint",
  clusters:    "cluster",
  agents:      "agent",
  providers:   "provider",
  models:      "model",
  sessions:    "session",
  files:       "file",
  hosts:       "host",
  skills:      "skill",
  memories:    "memory",
  commands:    "command",
  urls:        "url",
  tools:       "tool_call",
  mcp_servers: "mcp_server",
  projects:    "project",
  identities:  "identity",
  signals:     "signal",
};

export const dimSingularOf = (dimKey) => DIM_SINGULAR[dimKey] ?? dimKey;

// Scope dims the traces query (getTraces' scope loop in apiClient.js) can
// express as analytics predicates: the core PROMPT fields, the cluster
// subtree, the SignalTags joins (signal/skill/memory), the identity join,
// and the adapter dims that compose with the PROMPT graph. Everything else
// fails closed there, so a scope-carrying evidence pull must drop such steps
// (and disclose them) rather than empty every result.
//
// A static set, NOT a registry lookup, so this stays a leaf; the parity test
// (scopeDims.parity.test.js) pins it against the live dim-adapter registry,
// so a new composing adapter dim fails that test until it is added here. An
// omission fails open with disclosure: the pipelines skip the check for that
// dim and say so, they do not break.
const TRACE_SCOPE_EXPRESSIBLE = new Set([
  "endpoint", "session", "agent", "provider", "model", "cluster", "tool_call",
  "identity", "signal", "skill", "memory", "mcp_server",
]);

export function isTraceScopeExpressibleDim(dimKey) {
  return TRACE_SCOPE_EXPRESSIBLE.has(dimSingularOf(dimKey));
}
